/* eslint-disable no-console */
import { useCallback, useEffect, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
// import { DocxEditor } from "@eigenpal/docx-editor-react";
import { DocxEditor, createEmptyDocument } from "@eigenpal/docx-editor-react";

import {
  getToken,
  getLoggedInUserId,
  getCaseId,
  getClientId,
  getLoggedInUserName,
} from "../../Utils/helper";
import "./wordprocessor.css";
import { api_without_cancellation } from "../../api/api";
import { toSentenceCase } from "../DocumentModal/DocumentSideBar/DocumentModalSideBar";
import NewChatIcon from "../../assets/NewChatIcon";
import UploadIcon from "../../../public/bp_assets/img/cloud_icon.svg";
import mixColorWithWhite from "../TreatmentPage/utils/helperFn";
import TFIcon from "../../Components/TreatmentPage/icon/treatment-first-icon-2.png";
import { useChat } from "../AChatWindow/hooks/useChat";
import ChatWindow from "../AChatWindow/components/ChatWindow";

import { useCollaboration, pickColor } from "./collab/useCollaboration";
// eslint-disable-next-line import/order
import { useCollabSession } from "./collab/useCollabSession";
// eslint-disable-next-line import/no-unresolved
import "@eigenpal/docx-editor-react/styles.css";

import ChatDocumentModalWord from "./ChatDocumentModalWord";
import { handleVariableChange2 } from "./helpers";
const EMPTY_DOC = createEmptyDocument();
function WPBaseDraftPage({
  docId,
  updatedDocId,
  dynamicTemplateId,
  setPageId,
  setDropdownId,
  setDocName,
  state,
  dispatch,
  container,
  controls,
  type,
  clientData,
  print,
  download,
  sendEmail,
  deleteDoc,
  draftId,
  setTotalPages,
  setPageNumber,
  height2 = 5,
  setTabCollab,
  handleCloseTab,
}) {
  const _userId = getLoggedInUserId();
  const loggedInUserName = getLoggedInUserName();
  // const [isPropertyPaneReady, setIsPropertyPaneReady] = useState(false);

  const [dropdownPages, setDropdownPages] = useState([]);
  const [selectedPageOption, setSelectedPageOption] = useState(null);

  const [dropdownVariables, setDropdownVariables] = useState([]);

  const [_footerKey, _setFooterKey] = useState(0);

  const [renameDoc, setRenameDoc] = useState("");

  const origin = process.env.REACT_APP_BACKEND_URL || "https://dev.simplefirm.com";
  const _token = getToken();

  const saveTimeoutRef = useRef(null);
  const isDocumentReadyRef = useRef(false);
  const session = useCollabSession(docId);
  const collabEnabled = session?.enabled === true;
  const collabEnabledRef = useRef(false);
  collabEnabledRef.current = collabEnabled;
  const exportInFlight = useRef(false);
  const [collabSynced, setCollabSynced] = useState(false);
  const seedEditorRef = useRef({ current: null });
  const [seedNode, setSeedNode] = useState(null);
  // const loadFile = useCallback(
  //   async (file) => {
  //     try {
  //       const ajax = new XMLHttpRequest();
  //       ajax.open("POST", container.current?.serviceUrl + "Import", true);
  //       ajax.onreadystatechange = () => {
  //         if (ajax.readyState === 4 && ajax.status === 200) {
  //           container.current?.documentEditor.open(ajax.responseText);
  //           dispatch({ type: "SET_LOADING", payload: false });
  //           // Mark document as ready after it's loaded
  //           setTimeout(() => {
  //             isDocumentReadyRef.current = true;
  //           }, 1000);
  //         } else if (ajax.readyState === 4) {
  //           dispatch({ type: "SET_ERROR", payload: true });
  //         }
  //       };
  //       const formData = new FormData();
  //       formData.append("files", file);
  //       ajax.send(formData);
  //     } catch (error) {
  //       dispatch({ type: "SET_ERROR", payload: true });
  //     }
  //   },
  //   [container, dispatch]
  // );

  // const getDocument = useCallback(async () => {
  //   try {
  //     const response = await api_without_cancellation.get(
  //       `${origin}/api/getDocFile/?doc_id=${updatedDocId ? updatedDocId : docId}`
  //     );
  //     if (response.status === 200) {
  //       const fileResponse = await fetch(response?.data?.upload);
  //       const fileBlob = await fileResponse.blob();
  //       loadFile(fileBlob);
  //     }

  //     // }
  //   } catch (error) {
  //     dispatch({ type: "SET_ERROR", payload: true });
  //   }
  // }, [dispatch, docId, loadFile, origin, updatedDocId]);

  const handleControl = useCallback(
    async (msg) => {
      if (msg.type === "export_request") {
        if (exportInFlight.current || !container.current) return;
        if (session?.seedSource === "yjs" && !collabSynced) return;
        exportInFlight.current = true;
        try {
          const buf = await container.current.save({ selective: false });
          if (buf && buf.byteLength > 0) {
            const file = new File([buf], `document-${msg.doc_id}.docx`, {
              type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            });
            const fd = new FormData();
            fd.append("doc_id", String(msg.doc_id));
            fd.append("file", file);
            fd.append("collab_export", "1");
            fd.append("export_token", String(msg.export_token));
            await api_without_cancellation.post("/api/update-edit-doc/", fd, {
              headers: { "Content-Type": "multipart/form-data" },
            });
          }
        } catch (e) {
          console.error("collab export failed", e);
        } finally {
          exportInFlight.current = false;
        }
      } else if (msg.type === "error" || msg.type === "fatal") {
        // 4030/4031/4040 etc — surface access-denied / fall back per spec §11.
        console.error("collab control", msg);
      }
    },
    [container, session, collabSynced]
  );
  console.log(loggedInUserName);
  console.log(session);
  const collab = useCollaboration({
    enabled: collabEnabled && (session?.seedSource === "yjs" || seedNode !== null),
    wsPath: session?.wsPath,
    docId,
    user: { name: loggedInUserName, color: pickColor(_userId), userId: _userId },
    onControl: handleControl,
    seedSource: session?.seedSource,
    getSeedDoc: () => seedNode,
  });

  useEffect(() => {
    if (!collab) return undefined;
    const onSynced = () => setCollabSynced(true);
    collab.provider.on("synced", onSynced);
    if (collab.provider.synced) setCollabSynced(true);
    return () => collab.provider.off("synced", onSynced);
  }, [collab]);

  // Best-effort final export when this looks like the last editor (spec §12).
  useEffect(() => {
    if (!collab) return undefined;
    const onHide = async () => {
      if (collab.provider.awareness.getStates().size !== 1) return;
      if (!container.current) return;
      try {
        const buf = await container.current.save({ selective: false });
        if (!buf || buf.byteLength === 0) return;
        const fd = new FormData();
        fd.append("doc_id", String(docId));
        fd.append(
          "file",
          new File([buf], `document-${docId}.docx`, {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          })
        );
        fd.append("collab_export", "1"); // NO export_token on final save
        await api_without_cancellation.post("/api/update-edit-doc/", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } catch {
        /* browsers may cancel on unload; best-effort only */
      }
    };
    window.addEventListener("pagehide", onHide);
    return () => window.removeEventListener("pagehide", onHide);
  }, [collab, docId, container]);
  const [buffer, setBuffer] = useState(null);
  const getDocument = useCallback(async () => {
    try {
      const response = await api_without_cancellation.get(
        `/api/getDocFile/?doc_id=${updatedDocId ? updatedDocId : docId}`
      );
      if (response.status === 200) {
        // no-store: S3 objects carry a 24h Cache-Control header; never serve
        // a previously cached (older) copy of the document
        const fileResponse = await fetch(response?.data?.upload, { cache: "no-store" });

        const arrayBuffer = await fileResponse.arrayBuffer();
        console.log(arrayBuffer);
        setBuffer(arrayBuffer);
        dispatch({ type: "SET_LOADING", payload: false });
        setTimeout(() => {
          isDocumentReadyRef.current = true;
        }, 1000);
      }
    } catch (error) {
      dispatch({ type: "SET_ERROR", payload: true });
    }
  }, [dispatch, docId, updatedDocId]);
  const handlePageChange = (option) => {
    setSelectedPageOption(option);
    documentVariables(option.value);
  };
  const [contentUpdated, setContentUpdated] = useState(true);
  console.log("1 buffer", buffer?.byteLength);
  const autoSaveContent = useCallback(() => {
    if (collabEnabledRef.current) return;
    // Clear any pending save
    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    }

    // Debounce the save operation
    saveTimeoutRef.current = setTimeout(async () => {
      if (!container.current) {
        // Editor unmounted; the close path is responsible for the final save
        return;
      }
      if (!isDocumentReadyRef.current) {
        // Document still loading — reschedule instead of dropping the edit
        autoSaveContent();
        return;
      }

      try {
        // const documentEditor = container.current.documentEditor;
        // if (!documentEditor || !documentEditor.documentHelper) {
        //   return;
        // }

        // Save as Docx blob with proper error handling
        // const content = await Promise.race([
        //   documentEditor.saveAsBlob("Docx"),
        //   new Promise((_, reject) => setTimeout(() => reject(new Error("Save timeout")), 5000)),
        // ]);

        // Validate content
        // if (!content || content.size === 0) {
        //   return;
        // }
        const content = await Promise.race([
          container.current.save(),
          new Promise((_, reject) => setTimeout(() => reject(new Error("Save timeout")), 5000)),
        ]);
        if (!content || content.byteLength === 0) return;
        const file = new File([content], "autosave.docx", {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        const formData = new FormData();
        formData.append("doc_id", docId);
        formData.append("file", file);

        // Use UpdateEditDoc for all auto-saves (templates, drafts, etc.)
        // It saves in place on the original doc (and refreshes the EditDoc
        // lock); DeleteEditDoc on close just releases the lock.
        await api_without_cancellation.post(
          `${origin}/api/update-edit-doc/`,
          // { doc_id: docId, file: content },
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      } catch (error) {
        // Silently fail - the error is likely due to incomplete document state
        // This prevents the zip-archive error from showing in console
      }
    }, 2000); // Wait 2 seconds after user stops typing
  }, [docId, origin]);

  // Cancel any pending debounced save on unmount; it would fire against a
  // nulled editor ref. Callers that close the document flush explicitly.
  useEffect(() => {
    return () => {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
    };
  }, []);

  const getTemplateData = async (options) => {
    try {
      const response = await api_without_cancellation.get(
        "/api/firmsetting-page/edit-dl-template/",
        {
          params: {
            template_id: dynamicTemplateId,
          },
        }
      );
      if (response.status === 200) {
        const page_id = response.data?.for_page?.id;
        const dropdown_id = response.data?.for_dropdown?.id;
        const temp_name =
          response.data?.for_template?.template_name ??
          response.data?.for_dynamic_letter_template?.for_template?.template_name;
        const doc_name =
          response.data?.for_template?.template?.file_name ??
          response.data?.for_dynamic_letter_template?.for_template?.template?.file_name;

        const copy_temp_name = temp_name + "-copy";

        setPageId(page_id);
        setDropdownId(dropdown_id);

        setDocName(doc_name);
        setRenameDoc(doc_name);

        dispatch({
          type: "SET_TEMP_NAME",
          payload: temp_name,
        });

        dispatch({ type: "SET_FILENAME", payload: copy_temp_name });
        dispatch({ type: "SET_UPDATED_FILENAME", payload: copy_temp_name });

        const optionSelect = options.find((option) => option.value === page_id);
        setSelectedPageOption(optionSelect);
        documentVariables(page_id);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    // Append custom select dropdown to the property tab once it's rendered
    // if (container.current) {
    //   const element = document.querySelector(
    //     ".e-de-ctnr-properties-pane-btn.e-de-pane-disable-clr"
    //   );
    //   if (element) {
    //     element.classList.add("d-none");
    //   }
    //   componentDidMount();
    // }
    // setIsPropertyPaneReady(true); // Property tab is ready for rendering the select component
    documentPages();
  }, []);

  const documentPages = async () => {
    try {
      const response = await api_without_cancellation.get(
        `${origin}/api/firmsetting-page/get-document-variables-pages/`
      );

      if (response.status === 200) {
        const data = response.data;
        const optionPages = [
          {
            value: "all", // or another value of your choice
            label: "All",
          },
          ...data.map((item) => ({
            value: item.id, // map to `value`
            label: (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src={item.page_icon}
                  alt="icon"
                  style={{ width: "20px", marginRight: "8px" }}
                />
                {item.name}
              </div>
            ),
          })),
        ];
        setDropdownPages(optionPages);
        getTemplateData(optionPages);
      }
    } catch {
      setDropdownPages([]);
    }
  };

  const documentVariables = async (page_id) => {
    try {
      const response = await api_without_cancellation.get(
        `${origin}/api/firmsetting-page/get-document-variables/?page_id=` + page_id
      );

      if (response.status === 200) {
        const data = response.data;
        const filteredData = data.filter((item) => item.button_name !== null);
        setDropdownVariables(filteredData);
      }
    } catch {
      setDropdownVariables([]);
    }
  };

  const renameDocFileName = async () => {
    try {
      const formData = new FormData();
      formData.append("doc_id", docId);
      formData.append("file_name", renameDoc);

      const response = await api_without_cancellation.post(
        `${origin}/api/rename-doc-wp/`,
        formData
      );
      if (response.status === 200) {
        if (response.data.success) {
          dispatch({
            type: "SHOW_MODAL",
            payload: `${renameDoc} renamed successfully!`,
          });
          setDocName(renameDoc);
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  // useEffect(() => {
  //   // if (container.current) {
  //   getDocument();
  //   // }
  // }, [getDocument]);
  useEffect(() => {
    console.log("5g", {
      session: session?.seedSource,
      collabEnabled,
      willFetch: !(collabEnabled && session?.seedSource === "yjs"),
    });
    if (session === null) return;
    console.log("5g", {
      session: session?.seedSource,
      collabEnabled,
      willFetch: !(collabEnabled && session?.seedSource === "yjs"),
    });
    setTabCollab?.(session.enabled === true); // wait for the collab decision
    if (collabEnabled && session.seedSource === "yjs") {
      dispatch({ type: "SET_LOADING", payload: false }); // Yjs owns content
      return;
    }
    // legacy AND collab "docx" seeder both need the parsed buffer
    getDocument();
  }, [session, collabEnabled, getDocument, dispatch]);

  const [containerHeight, setContainerHeight] = useState(21);
  const textRef = useRef(null);
  const LINE_HEIGHT = 21;
  const MAX_HEIGHT = 84;

  useEffect(() => {
    if (textRef.current) {
      const element = textRef.current;
      const scrollHeight = element.scrollHeight;
      const numberOfLines = Math.ceil(scrollHeight / LINE_HEIGHT);
      const newHeight = Math.min(numberOfLines * LINE_HEIGHT, MAX_HEIGHT);
      setContainerHeight(newHeight);
    }
  }, [state?.tempName]);

  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({
    chatDoc: false,
    taskLink: false,
    docReview: false,
  });
  const dropdownRefs = {
    chatDoc: useRef(null),
    taskLink: useRef(null),
    docReview: useRef(null),
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      Object.entries(dropdownRefs).forEach(([key, ref]) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setDropdownOpen((prev) => ({ ...prev, [key]: false }));
        }
      });
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [pages, setPages] = useState([]);
  const [slotsData, setSlotsData] = useState([]);
  const [showMenuBar, setShowMenuBar] = useState(false);
  const [panelMenuBar, setPanelMenuBar] = useState(false);
  const [documentPanelsData, setDocumentPanelsData] = useState(null);

  const splitItemsIntoCol = (items) => {
    const totalItems = items.length;
    const midPoint = Math.ceil(totalItems / 2);

    return {
      leftCol: items.slice(0, midPoint),
      rightCol: items.slice(midPoint),
    };
  };

  const displayablePages = pages.filter((page) => {
    const slotData = slotsData?.find((slot) => slot?.page?.name === page?.name);
    return page?.is_notes_category && slotData && slotData.page_slots.length > 0;
  });

  const { leftCol, rightCol } = splitItemsIntoCol(displayablePages);

  useEffect(() => {
    const fetchDataFirstTime = async () => {
      try {
        const response = await api_without_cancellation.get(
          "api/doc-page/list-page-doc-optimized/",
          {
            params: {
              page_id: "",
              case_id: clientData ? clientData?.case?.id : getCaseId(),
              all_docs: "True",
              client_id: clientData ? clientData?.client?.id : getClientId(),
            },
          }
        );
        if (response.status === 200) {
          setSlotsData(response.data.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (clientData) {
      fetchDataFirstTime();
    }
  }, [clientData]);

  const refetchDocumentChanges = async () => {
    try {
      const response = await api_without_cancellation.get("api/doc-page/list-page-doc-optimized/", {
        params: {
          page_id: "",
          case_id: clientData ? clientData?.case?.id : getCaseId(),
          all_docs: "True",
          client_id: clientData ? clientData?.client?.id : getClientId(),
        },
      });
      if (response.status === 200) {
        setSlotsData(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const [pdfDocId, setPdfDocId] = useState(null);
  const [confirmationModal, setConfirmationModal] = useState(false);

  const fetchPageDetails = async (caseId) => {
    try {
      const response = await api_without_cancellation.get(`/api/pages/${caseId}/`);

      setPages(response.data);
    } catch (error) {
      console.error("Error occurred while fetching pages", error);
    }
  };

  useEffect(() => {
    setPages([]);
    if (clientData?.case?.id) {
      fetchPageDetails(clientData?.case?.id);
    }
  }, [clientData]);
  const [pendingSlotAction, setPendingSlotAction] = useState(null);
  // shape: { slot, docsInSlot }

  const handleCancel = () => {
    setPendingSlotAction(null);
    setConfirmationModal(false);
  };

  const submitDocument = async ({ slot, page, action, isPanels = false }) => {
    // const documentEditor = container.current.documentEditor;
    // if (!documentEditor || !documentEditor.documentHelper) {
    //   return;
    // }

    // Save as Docx blob with proper error handling
    // const blob = await Promise.race([
    //   documentEditor.saveAsBlob("Docx"),
    //   new Promise((_, reject) => setTimeout(() => reject(new Error("Save timeout")), 5000)),
    // ]);
    const blob = await Promise.race([
      container.current.save(),
      new Promise((_, reject) => setTimeout(() => reject(new Error("Save timeout")), 5000)),
    ]);

    const docxFile = new File([blob], `${state?.tempName || "document"}.docx`, {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });
    const formData = new FormData();

    formData.append("case_id", getCaseId());
    formData.append("client_id", getClientId());
    formData.append("page_id", page?.id);
    if (pdfDocId && !contentUpdated) {
      // If pdf_doc_id exists, send only the ID
      formData.append("pdf_doc_id", String(pdfDocId));
    } else {
      // Otherwise send the file
      formData.append("file", docxFile);
    }
    formData.append("is_draft_changed", contentUpdated ? true : false);
    formData.append("draft_id", draftId);
    formData.append("slot", slot?.id);
    formData.append("is_panels", isPanels);
    formData.append("move_to_page", action === "move" ? true : false);
    formData.append("delete_and_replace", action === "delete" ? true : false);
    try {
      const res = await api_without_cancellation.post("/api/documents/pdf-to-casefile/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setContentUpdated(false);

      setPdfDocId(res?.data?.doc_id);

      refetchDocumentChanges();
    } catch (error) {
      console.error(error);
      // setSlotsData(previousSlotData);
    }
  };

  const submitDocumentWithPanel = async ({ slot, page, panel, action, isPanels = true }) => {
    // const documentEditor = container.current.documentEditor;
    // if (!documentEditor || !documentEditor.documentHelper) {
    //   return;
    // }

    // Save as Docx blob with proper error handling
    // const blob = await Promise.race([
    //   documentEditor.saveAsBlob("Docx"),
    //   new Promise((_, reject) => setTimeout(() => reject(new Error("Save timeout")), 5000)),
    // ]);
    const blob = await Promise.race([
      container.current.save(),
      new Promise((_, reject) => setTimeout(() => reject(new Error("Save timeout")), 5000)),
    ]);

    const docxFile = new File([blob], `${state?.tempName || "document"}.docx`, {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });
    const formData = new FormData();

    formData.append("case_id", getCaseId());
    formData.append("client_id", getClientId());
    formData.append("page_id", page?.id);
    if (pdfDocId && !contentUpdated) {
      // If pdf_doc_id exists, send only the ID
      formData.append("pdf_doc_id", String(pdfDocId));
    } else {
      // Otherwise send the file
      formData.append("file", docxFile);
    }
    formData.append("is_draft_changed", contentUpdated ? true : false);
    formData.append("draft_id", draftId);
    formData.append("slot", slot?.id);
    formData.append("panel_id", panel?.id);
    formData.append("is_panels", isPanels);
    formData.append("move_to_page", action === "move" ? true : false);
    formData.append("delete_and_replace", action === "delete" ? true : false);
    try {
      const res = await api_without_cancellation.post("/api/documents/pdf-to-casefile/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setContentUpdated(false);

      setPdfDocId(res?.data?.doc_id);

      refetchDocumentChanges();
    } catch (error) {
      console.error(error);
      // setSlotsData(previousSlotData);
    }
  };

  const {
    users,
    loading: chatLoading,
    error: chatError,
    sendMessage,
    searchUsers,
    messages,
    typingUsers,
    handleTyping,
    markAsRead,
    loadMoreMessages,
    handleSelectUser,
  } = useChat({ skipInitialization: true });
  const [updatedUser, setUpdatedUser] = useState({});
  const [chatDocumentThread, setChatDocumentThread] = useState(false);

  const handleMoveExisting = async () => {
    if (!pendingSlotAction) return;

    const { slot, page, panel } = pendingSlotAction;
    setConfirmationModal(false);
    if (!panel) {
      await submitDocument({
        slot,
        page,
        action: "move",
      });
    } else {
      await submitDocumentWithPanel({
        slot,
        page,
        panel,
        action: "move",
      });
    }

    setPendingSlotAction(null);
  };
  const handleDeleteExisting = async () => {
    if (!pendingSlotAction) return;

    const { slot, page, panel } = pendingSlotAction;

    setConfirmationModal(false);

    if (!panel) {
      await submitDocument({
        slot,
        page,
        action: "delete",
      });
    } else {
      await submitDocumentWithPanel({
        slot,
        page,
        panel,
        action: "delete",
      });
    }

    setPendingSlotAction(null);
  };

  // Letter Temp
  const [dropdownOpenManual, setDropdownOpenManual] = useState(false);
  const pageDropdownRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (pageDropdownRef.current && !pageDropdownRef.current.contains(event.target)) {
        setDropdownOpenManual(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pageDropdownRef]);
  const getPageCount = () => {
    if (!container.current) return 1;

    // Try the direct method first
    const direct = container.current.getTotalPages?.();
    if (direct && direct > 1) return direct;

    // Fall back to layout engine
    const editorRef = container.current.getEditorRef?.();
    const layout = editorRef?.getLayout?.();
    if (layout?.pages?.length) return layout.pages.length;

    return 1;
  };
  const seedPollRef = useRef(null);
  useEffect(
    () => () => {
      if (seedPollRef.current) clearInterval(seedPollRef.current);
    },
    []
  );
  console.log("4 mount", session?.seedSource, "collab?", !!collab, "seedNode?", seedNode !== null);
  if (!docId || state.error) {
    return (
      <div className="doc-error">
        <p>Document not found!</p>
      </div>
    );
  }

  return (
    <>
      <div
        className="d-flex align-items-center m-t-5"
        style={{
          height: `calc(100% - ${height2}px)`,
          width: "100%",
          overflow: "hidden",
        }}
      >
        <div
          // className=" ps-0 pe-0"
          className={`ps-0 pe-0 ${["GenerateDocument", "Draft"].includes(type) ? "" : ""}`}
          style={{
            opacity: state.loading ? 0 : 1,
            pointerEvents: state.loading ? "none" : "auto",
            height: "100%",
            width: chatDocumentThread
              ? "50%"
              : ["GenerateDocument", "Draft"].includes(type)
                ? "80%"
                : "calc(100% - 350px)",
            flexGrow: "1",
            ...(["GenerateDocument", "Draft"].includes(type) &&
              {
                // width: `calc(100% - ${chatDocumentThread ? 680 : 220}px)`,
                // minWidth: `calc(100% - ${chatDocumentThread ? 680 : 220}px)`,
                // flex: 1,
                // maxWidth: "calc(100% - 220px)",
              }),
          }}
        >
          <>
            {collabEnabled ? (
              <>
                {/* 1. HIDDEN PRE-PARSE — docx seeder only, only until parsed. ADD THIS. */}
                {collabEnabled && session.seedSource === "docx" && seedNode === null && buffer && (
                  <div
                    style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}
                    aria-hidden
                  >
                    <DocxEditor
                      ref={seedEditorRef}
                      documentBuffer={buffer}
                      externalContent={false}
                      mode="editing"
                      showToolbar={false}
                      onEditorViewReady={(view) => {
                        // Prefer the view passed in — it's guaranteed live here.
                        // const grab = () => {
                        //   const doc =
                        //     view?.state?.doc ||
                        //     seedEditorRef.current?.getEditorRef?.()?.getState?.()?.doc ||
                        //     seedEditorRef.current?.getEditorRef?.()?.getView?.()?.state?.doc;
                        //   console.log("2 seed doc size", doc?.content?.size, "children", doc?.childCount);
                        //   if (doc && doc.content.size > 0) {
                        //     setSeedNode(doc);
                        //     return true;
                        //   }
                        //   return false;
                        // };
                        const grab = () => {
                          try {
                            const doc =
                              view?.state?.doc ||
                              seedEditorRef.current?.getEditorRef?.()?.getState?.()?.doc;
                            if (doc && doc.content.size > 0) {
                              setSeedNode(doc);
                              return true;
                            }
                          } catch {
                            return true;
                          } // view gone — stop polling
                          return false;
                        };
                        if (grab()) return;
                        let tries = 0;
                        seedPollRef.current = setInterval(() => {
                          tries += 1;
                          if (grab() || tries > 20) {
                            clearInterval(seedPollRef.current);
                            seedPollRef.current = null;
                          }
                        }, 100);
                        // if (grab()) return;
                        // // View ready but doc not parsed yet — poll a few frames.
                        // let tries = 0;
                        // const id = setInterval(() => {
                        //   tries += 1;
                        //   if (grab() || tries > 20) clearInterval(id);
                        // }, 100);
                      }}
                    />
                  </div>
                )}

                {/* 2. REAL COLLAB EDITOR — unchanged from 5h. Mounts once `collab` exists. */}
                {collab ? (
                  <>
                    {session.seedSource === "yjs" && !collabSynced && (
                      <div className="d-flex align-items-center justify-content-center h-100">
                        Joining collaborative session…
                      </div>
                    )}
                    <DocxEditor
                      ref={container}
                      document={EMPTY_DOC} // BOTH sources use EMPTY_DOC now —
                      externalContent // docx content comes from the pre-seeded fragment
                      externalPlugins={collab.plugins}
                      mode="editing"
                      documentName={state?.tempName}
                      showToolbar
                      showRuler={false}
                      showZoomControl={false}
                      onChange={() => {
                        setContentUpdated(true);
                        const total = getPageCount();
                        if (total) setTotalPages(total);
                      }}
                      onSelectionChange={() => {
                        const current = container.current?.getCurrentPage?.();
                        if (current) setPageNumber(current);
                      }}
                      style={{
                        height: "calc(100% - 5px)",
                        visibility:
                          session.seedSource === "yjs" && !collabSynced ? "hidden" : "visible",
                      }}
                    />
                  </>
                ) : (
                  <div className="d-flex align-items-center justify-content-center h-100">
                    Connecting…
                  </div>
                )}
              </>
            ) : (
              buffer && (
                <DocxEditor
                  ref={container}
                  documentBuffer={buffer}
                  mode="editing"
                  documentName={state?.tempName}
                  showToolbar
                  showRuler={false}
                  showZoomControl={false}
                  onChange={() => {
                    autoSaveContent();
                    setContentUpdated(true);
                    const total = getPageCount();
                    if (total) setTotalPages(total);
                  }}
                  onSelectionChange={() => {
                    const current = container.current?.getCurrentPage?.();
                    if (current) setPageNumber(current);
                  }}
                  onFontsLoaded={() => {
                    isDocumentReadyRef.current = true;
                    setTimeout(() => {
                      const total = getPageCount();
                      if (total) setTotalPages(total);
                    }, 500);
                  }}
                  style={{ height: "calc(100% - 5px)" }}
                />
              )
            )}
          </>
        </div>

        <div
          className={`ps-0 p-r-5 ${["GenerateDocument", "Draft"].includes(type) ? "" : ""}`}
          style={
            ["GenerateDocument", "Draft"].includes(type)
              ? { minWidth: "220px", maxWidth: "220px", height: "100%" }
              : ["LetterTemplate"].includes(type)
                ? { minWidth: "220px", maxWidth: "220px", height: "100%" }
                : { minWidth: "350px", maxWidth: "350px", height: "100%" }
          }
        >
          {!["GenerateDocument", "Draft"].includes(type) && (
            <div className="row mx-auto">
              <div className="col-sm-12 ps-0 pe-0">{controls ? controls : controls}</div>
            </div>
          )}

          {["GenerateDocument", "Draft"].includes(type) && (
            <>
              <div
                className="right-sidebar d-flex flex-column"
                style={{ width: "220px", zIndex: "1", minWidth: "220px", height: "100%" }}
              >
                <div
                  className="d-flex flex-column justify-content-between h-100"
                  style={{
                    backgroundColor: "#f2f5f7",
                  }}
                >
                  {/* Case Block */}
                  {/* <div>
                    <span
                      className="color-main text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
                      style={{
                        fontSize: "14px",
                        height: "25px",
                        borderRadius: "0px",
                      }}
                    >
                      CASE
                    </span>
                    <div
                      className="client-name d-flex align-items-center side-bar-padding"
                      style={{ height: "25px", background: "var(--primary-2)" }}
                    >
                      <UserProfile clientInfo={clientData?.client} />
                    </div>
                    <div
                      className="tile-row w-100 p-l-5 p-r-5 d-flex flex-column align-items-start"
                      style={{ height: "42px", background: "var(--primary-4)" }}
                    >
                      <div className="d-flex align-items-center" style={{ height: "21px" }}>
                        {clientData?.case?.case_type?.icon && (
                          <span
                            className="ic-avatar ic-19 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                            style={{ marginRight: "5px" }}
                          >
                            <img
                              style={{
                                width: "15px",
                                height: "15px",
                              }}
                              src={clientData?.case?.case_type?.icon}
                              alt="icon"
                            />
                          </span>
                        )}

                        <p className="text-black font-weight-semibold d-block">
                          {clientData?.case?.case_type?.name || "N/A"}
                        </p>
                      </div>
                      <div className="d-flex align-items-center" style={{ height: "21px" }}>
                        <span
                          className="ic-avatar ic-19 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                          style={{ marginRight: "5px" }}
                        >
                          <img
                            src={incidentIcon}
                            className=""
                            style={{
                              width: "15px",
                              height: "15px",
                            }}
                          />
                        </span>

                        <p className="font-weight-semibold">
                          {formatCalendarDate(clientData?.case?.incident_date) || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div> */}

                  {/* Draft Name */}
                  <div>
                    <span
                      className="color-main m-t-0 text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
                      style={{
                        fontSize: "14px",
                        height: "25px",
                        borderRadius: "0px",
                      }}
                    >
                      DRAFT NAME
                    </span>

                    <div
                      className="tile-row mw-100 flex-wrap d-flex align-items-center p-l-5 p-r-5"
                      style={{
                        height: `${containerHeight}px`,
                        minHeight: "21px",
                        maxHeight: `${MAX_HEIGHT}px`,
                        transition: "height 0.1s ease",
                        overflow: "hidden",
                        background: "var(--primary-2)",
                      }}
                    >
                      <span
                        ref={textRef}
                        className="text-black text-start text-break font-weight-semibold d-block"
                      >
                        {state?.tempName}
                      </span>
                    </div>
                  </div>

                  {/* Create Document */}
                  <div className="">
                    <span
                      className="color-main text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
                      style={{
                        fontSize: "14px",
                        height: "25px",
                        borderRadius: "0px",
                      }}
                    >
                      Save PDF Copy To
                    </span>

                    <ul
                      className="d-flex document-pop-up-menu-sidebar"
                      style={{ paddingLeft: "0px", flexDirection: "row" }}
                    >
                      <div
                        style={{
                          flex: "1",
                        }}
                      >
                        {leftCol &&
                          leftCol.map((page, _index) => {
                            // Find the corresponding slot data for the current page
                            const slotData = slotsData.find((slot) => slot.page.name === page.name);

                            if (
                              page.is_notes_category &&
                              slotData &&
                              slotData.page_slots.length > 0
                            ) {
                              const { panels, page_slots } = slotData;

                              // If panels exist, show panels first

                              if (
                                page_slots.length > 0 &&
                                page.name === "Treatment" &&
                                page.panels
                              ) {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        top: "auto",
                                        // page.name === "Witnesses"
                                        //   ? `${index * 2 + 3}%`
                                        //   : "auto",
                                        left: "auto",
                                        minWidth: "auto",
                                        transform: "translate(10px, -20px)",
                                        right: "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "35px",
                                            // padding: "0 10px",
                                            paddingTop: "0px",
                                            paddingLeft: "25px",
                                            paddingRight: "10px",
                                            paddingBottom: "0px",
                                            // background: "white",
                                            cursor: "pointer",
                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }

                                            // Save as Docx blob with proper error handling
                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", true);
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-between"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}
                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          //
                                          height: "25px",
                                          padding: "0 10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {page?.panel_name}
                                        </span>
                                      </div>
                                      {panels?.length === 0 && (
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            // paddingLeft: "55px",
                                            height: "50px",
                                            padding: "0 10px",
                                            background: "var(--primary-2)",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "14px",
                                              color: "var(--primary-25)",
                                              width: "100%",
                                              // textTransform: "capitalize",
                                            }}
                                          >
                                            {toSentenceCase(`No ${page?.panel_name}`)}
                                          </span>
                                        </li>
                                      )}
                                      {panels.map((panel, panelIndex) => (
                                        <li
                                          key={panelIndex}
                                          className="d-flex align-items-center"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "25px",
                                          }}
                                          onMouseEnter={() => {
                                            setDocumentPanelsData(panel);
                                            setPanelMenuBar(panelIndex);
                                          }}
                                          onMouseLeave={() => {
                                            setDocumentPanelsData([]);
                                            setPanelMenuBar(null);
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer d-flex align-items-center color-grey-2"
                                            style={{ gap: "0px", width: "100%" }}
                                          >
                                            {/* <span
                                                        style={{
                                                          display: "inline-block",
                                                          width: "17px",
                                                          height: "17px",
                                                          color: "#19395F",
                                                          transform: "rotate(180deg)",
                                                          backgroundImage:
                                                            panelMenuBar === panelIndex
                                                              ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                                              : "",
                                                          backgroundRepeat: "no-repeat",
                                                          backgroundSize: "contain",
                                                        }}
                                                      ></span> */}
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              {panelIndex + 1}
                                            </span>
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              <img
                                                src={TFIcon}
                                                alt="tf-icon"
                                                style={{
                                                  height: "25px",
                                                  width: "25px",
                                                  position: "relative",
                                                  right: "0px",
                                                  bottom: "0px",
                                                }}
                                              />
                                            </span>

                                            <span
                                              className="d-flex align-items-center p-r-5 whitespace-nowrap"
                                              style={{
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                color: "black",
                                                width: "calc(100% - 25px)",
                                                background: mixColorWithWhite(
                                                  panel?.specialty?.color,
                                                  10
                                                ),
                                              }}
                                            >
                                              <span
                                                style={{
                                                  background: panel?.specialty?.color,

                                                  fontSize: "16px",
                                                  fontWeight: "700",
                                                  height: "25px",
                                                  width: "25px",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  color: "white",
                                                  marginRight: "5px",
                                                }}
                                              >
                                                {panel?.specialty?.name[0] ?? ""}
                                              </span>
                                              {panel?.panel_name ? panel.panel_name : ""}
                                            </span>
                                          </a>
                                          <ul
                                            className="document-pop-up-sidebar-menubar"
                                            style={{
                                              position: "absolute",
                                              // left: "auto",
                                              top:
                                                width < 1400
                                                  ? `${panelIndex * 2 + 18}%`
                                                  : `${10 + panelIndex * 2}%`,
                                              left: "auto",
                                              // top: "auto",
                                              minWidth: "250px",
                                              transform:
                                                width > 1400
                                                  ? `translate(0px, -${panelIndex + 15}%)`
                                                  : `translate(0px, -${panelIndex + 30}%)`,
                                              // right: "17.2%",
                                              right: "91%",
                                              display: panelMenuBar === panelIndex ? "block" : "",
                                              width: "max-content",
                                            }}
                                          >
                                            <li
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "0px",
                                                height: "25px",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "black",
                                                  width: "100%",
                                                  // background: documentData
                                                  //   ? mixColorWithWhite(
                                                  //       documentPanelsData?.specialty?.color,
                                                  //       10
                                                  //     )
                                                  //   : "",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    background:
                                                      documentPanelsData?.specialty?.color,
                                                    fontSize: "16px",
                                                    fontWeight: "700",
                                                    height: "25px",
                                                    width: "25px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    color: "white",
                                                    marginRight: "5px",
                                                  }}
                                                >
                                                  {documentPanelsData?.specialty?.name[0] ?? ""}
                                                </span>
                                                {documentPanelsData?.panel_name
                                                  ? documentPanelsData.panel_name
                                                  : ""}
                                              </span>
                                            </li>
                                            <li
                                              className="bg-primary-5 d-flex align-items-center"
                                              style={{
                                                paddingLeft: "55px",
                                                height: "25px",
                                                paddingRight: "10px",
                                                // background: "var(--primary-15)",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "var(--primary)",
                                                  width: "100%",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                Document Row Buttons
                                              </span>
                                            </li>
                                            {page_slots.map((slot, slotIndex) => {
                                              const docsInSlot = panel.documents?.filter(
                                                (doc) =>
                                                  doc.document_slot?.slot_number ===
                                                  slot?.slot_number
                                              );
                                              const handleClick = async () => {
                                                if (docsInSlot.length > 0) {
                                                  setPendingSlotAction({
                                                    slot,
                                                    docsInSlot,
                                                    page,
                                                    panel,
                                                  });
                                                  setConfirmationModal(true);
                                                  return;
                                                }

                                                await submitDocumentWithPanel({
                                                  slot,
                                                  page,
                                                  panel,
                                                });
                                              };
                                              return (
                                                slot.slot_number !== 0 && (
                                                  <li
                                                    key={slotIndex}
                                                    className="d-flex align-items-center"
                                                    style={{
                                                      padding: "0px 10px",
                                                      height: "25px",
                                                      background:
                                                        slotIndex % 2 === 0
                                                          ? mixColorWithWhite(
                                                              panel?.specialty?.color,
                                                              2
                                                            )
                                                          : mixColorWithWhite(
                                                              panel?.specialty?.color,
                                                              4
                                                            ),
                                                      cursor:
                                                        docsInSlot.length > 0
                                                          ? "default"
                                                          : "pointer",
                                                    }}
                                                    onClick={handleClick}
                                                  >
                                                    {slot.slot_number !== 0 && (
                                                      <span className="d-flex align-items-center justify-content-center">
                                                        {docsInSlot.length > 0 ? (
                                                          <i
                                                            className="ic ic-15 ic-file-colored cursor-pointer "
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        ) : (
                                                          <img
                                                            src={UploadIcon}
                                                            className=" ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        )}
                                                      </span>
                                                    )}
                                                    {/* 
                                                          {slot.slot_number === 0 && (
                                                            <span className="d-flex align-items-center ms-2">
                                                              <img
                                                                src={page.page_icon ?? ""}
                                                                className="document-icons-width  cursor-pointer m-r-5"
                                                                alt=""
                                                              />
                                                              Attach to {page.name} Page
                                                            </span>
                                                          )} */}

                                                    {slot.slot_number !== 0 && (
                                                      <div
                                                        className={`d-flex align-items-center whitespace-nowrap  ${
                                                          docsInSlot.length === 0
                                                            ? "hoverable-text"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          width: "calc(100% - 25px)",
                                                          fontWeight: "bold",
                                                          color:
                                                            docsInSlot.length === 0
                                                              ? "var(--primary-25)"
                                                              : "inherit",

                                                          // height: "25px",
                                                        }}
                                                      >
                                                        <>
                                                          <span className="ms-2 hoverable-text">
                                                            {slot.slot_number}.
                                                          </span>
                                                          <span className="ms-2 hoverable-text">
                                                            {docsInSlot.length > 0
                                                              ? docsInSlot[0].file_name
                                                              : slot.slot_name
                                                                ? slot.slot_name
                                                                : "Available"}
                                                          </span>
                                                        </>
                                                      </div>
                                                    )}
                                                  </li>
                                                )
                                              );
                                            })}
                                          </ul>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                );
                              }

                              if (page_slots.length > 0 && page.panels && page.name === "Loans") {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        top: "auto",
                                        // page.name === "Witnesses"
                                        //   ? `${index * 2 + 3}%`
                                        //   : "auto",
                                        left: "auto",
                                        minWidth: "auto",
                                        transform: "translate(10px, -20px)",
                                        right: width > 1400 ? "120px" : "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            padding: "0px 10px 0px 25px",
                                            height: "35px",
                                            cursor: "pointer",
                                            // background: "white",

                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);

                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", true);
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-between"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}
                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          // paddingLeft: "55px",
                                          height: "25px",
                                          padding: "0 10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {page?.panel_name}
                                        </span>
                                      </div>
                                      {panels?.length === 0 && (
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            // paddingLeft: "55px",
                                            height: "50px",
                                            padding: "0 10px",
                                            background: "var(--primary-2)",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "14px",
                                              color: "var(--primary-25)",
                                              width: "100%",
                                              // textTransform: "",
                                            }}
                                          >
                                            {toSentenceCase(`No ${page?.panel_name}`)}
                                          </span>
                                        </li>
                                      )}
                                      {panels.map((panel, panelIndex) => (
                                        <li
                                          key={panelIndex}
                                          className="d-flex align-items-center"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "25px",
                                          }}
                                          onMouseEnter={() => {
                                            setDocumentPanelsData(panel);
                                            setPanelMenuBar(panelIndex);
                                          }}
                                          onMouseLeave={() => {
                                            setDocumentPanelsData([]);
                                            setPanelMenuBar(null);
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer d-flex align-items-center color-grey-2"
                                            style={{ gap: "0px", width: "100%" }}
                                          >
                                            {/* <span
                                                        style={{
                                                          display: "inline-block",
                                                          width: "17px",
                                                          height: "17px",
                                                          color: "#19395F",
                                                          transform: "rotate(180deg)",
                                                          backgroundImage:
                                                            panelMenuBar === panelIndex
                                                              ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                                              : "",
                                                          backgroundRepeat: "no-repeat",
                                                          backgroundSize: "contain",
                                                        }}
                                                      ></span> */}
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              {panelIndex + 1}
                                            </span>
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              {/* <img
                                                          src={TFIcon}
                                                          alt="tf-icon"
                                                          style={{
                                                            height: "25px",
                                                            width: "25px",
                                                            position: "relative",
                                                            right: "0px",
                                                            bottom: "0px",
                                                          }}
                                                        /> */}
                                            </span>

                                            <span
                                              className="d-flex align-items-center p-r-5 whitespace-nowrap"
                                              style={{
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                color: "black",
                                                width: "calc(100% - 25px)",
                                                background: mixColorWithWhite(
                                                  panel?.specialty?.color,
                                                  10
                                                ),
                                              }}
                                            >
                                              {page?.name === "Offer" ? panel?.panel_name : ""}
                                              {page?.name !== "Offer"
                                                ? panel?.specialty
                                                  ? panel?.specialty.name
                                                  : panel?.panel_name
                                                    ? panel?.panel_name
                                                    : ""
                                                : ""}
                                            </span>
                                          </a>
                                          {/* <a
                                                      className="cursor-pointer d-flex align-items-center"
                                                      // style={{ gap: "5px" }}
                                                      style={{
                                                        color: "var(--primary-25)",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display: "inline-block",
                                                          width: "17px",
                                                          height: "17px",
                                                          color: "#19395F",
                                                          transform: "rotate(180deg)",
                                                          backgroundImage:
                                                            panelMenuBar === panelIndex
                                                              ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                              : "",
                                                          backgroundRepeat: "no-repeat",
                                                          backgroundSize: "contain",
                                                        }}
                                                      />
                                                      <span className="ms-2" style={{ fontWeight: "bold" }}>
                                                        {panelIndex + 1}.
                                                      </span>
                                                      <span
                                                        className="ms-2 whitespace-nowrap"
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: "var(--primary)",
                                                        }}
                                                      >
                                                        {page?.name === "Offer" ? panel?.panel_name : ""}
                                                        {page?.name !== "Offer"
                                                          ? panel?.specialty
                                                            ? panel?.specialty.name
                                                            : panel?.panel_name
                                                              ? panel?.panel_name
                                                              : ""
                                                          : ""}
                                                      </span>
                                                    </a> */}
                                          <ul
                                            className="document-pop-up-sidebar-menubar"
                                            style={{
                                              position: "absolute",
                                              // left: "auto",
                                              top:
                                                width < 1400
                                                  ? `${panelIndex * 2 + 18}%`
                                                  : `${10 + panelIndex * 2}%`,
                                              left: "auto",
                                              // top: "auto",
                                              minWidth: "auto",
                                              transform:
                                                width > 1400
                                                  ? `translate(0px, -${panelIndex + 15}%)`
                                                  : `translate(0px, -${panelIndex + 30}%)`,
                                              // right: "17.2%",
                                              right: "88%",
                                              display: panelMenuBar === panelIndex ? "block" : "",
                                              width: "max-content",
                                            }}
                                          >
                                            <li
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "0px",
                                                height: "25px",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "black",
                                                  width: "100%",
                                                }}
                                              >
                                                <span
                                                  className="p-l-5 d-flex align-items-center"
                                                  style={{
                                                    width: "25px",
                                                    height: "25px",
                                                  }}
                                                >
                                                  <img
                                                    src={page.page_icon ?? ""}
                                                    className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                    // className="document-icons-width"
                                                    alt=""
                                                    style={{
                                                      width: "15px",
                                                      height: "15px",
                                                    }}
                                                  />
                                                </span>
                                                {documentPanelsData?.panel_name
                                                  ? documentPanelsData.panel_name
                                                  : ""}
                                              </span>
                                            </li>
                                            <li
                                              className="bg-primary-5 d-flex align-items-center"
                                              style={{
                                                paddingLeft: "55px",
                                                height: "25px",
                                                paddingRight: "10px",
                                                // background: "var(--primary-15)",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "var(--primary)",
                                                  width: "100%",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                Document Row Buttons
                                              </span>
                                            </li>
                                            {page_slots.map((slot, slotIndex) => {
                                              const docsInSlot = panel.documents?.filter(
                                                (doc) =>
                                                  doc.document_slot?.slot_number ===
                                                  slot?.slot_number
                                              );
                                              const handleClick = async () => {
                                                if (docsInSlot.length > 0) {
                                                  setPendingSlotAction({
                                                    slot,
                                                    docsInSlot,
                                                    page,
                                                    panel,
                                                  });
                                                  setConfirmationModal(true);
                                                  return;
                                                }

                                                await submitDocumentWithPanel({
                                                  slot,
                                                  page,
                                                  panel,
                                                });
                                              };
                                              return (
                                                slot.slot_number !== 0 && (
                                                  <li
                                                    key={slotIndex}
                                                    className="d-flex align-items-center"
                                                    style={{
                                                      padding: "0px 10px",
                                                      height: "25px",
                                                      cursor:
                                                        docsInSlot.length > 0
                                                          ? "default"
                                                          : "pointer",
                                                    }}
                                                    onClick={handleClick}
                                                  >
                                                    {slot.slot_number !== 0 && (
                                                      <span className="d-flex align-items-center justify-content-center">
                                                        {docsInSlot.length > 0 ? (
                                                          <i
                                                            className="ic ic-15 ic-file-colored cursor-pointer "
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        ) : (
                                                          <img
                                                            src={UploadIcon}
                                                            className=" ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        )}
                                                      </span>
                                                    )}
                                                    {/* 
                                                          {slot.slot_number === 0 && (
                                                            <span className="d-flex align-items-center ms-2">
                                                              <img
                                                                src={page.page_icon ?? ""}
                                                                className="document-icons-width  cursor-pointer m-r-5"
                                                                alt=""
                                                              />
                                                              Attach to {page.name} Page
                                                            </span>
                                                          )} */}

                                                    {slot.slot_number !== 0 && (
                                                      <div
                                                        className={`d-flex align-items-center  ${
                                                          docsInSlot.length === 0
                                                            ? "hoverable-text"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          width: "calc(100% - 25px)",
                                                          fontWeight: "bold",
                                                          // height: "25px",
                                                          color:
                                                            docsInSlot.length === 0
                                                              ? "var(--primary-25)"
                                                              : "inherit",
                                                        }}
                                                      >
                                                        <>
                                                          <span className="ms-2 hoverable-text">
                                                            {slot.slot_number}.
                                                          </span>
                                                          <span className="ms-2 hoverable-text whitespace-nowrap">
                                                            {docsInSlot.length > 0
                                                              ? docsInSlot[0].file_name
                                                              : slot.slot_name
                                                                ? slot.slot_name
                                                                : "Available"}
                                                          </span>
                                                        </>
                                                      </div>
                                                    )}
                                                  </li>
                                                )
                                              );
                                            })}
                                          </ul>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                );
                              }

                              if (page_slots.length > 0 && page.panels) {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      {/* <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "17px",
                                                    height: "17px",
                                                    color: "#19395F",
                                                    transform: "rotate(180deg)",
                                                    backgroundImage:
                                                      showMenuBar === index
                                                        ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                                        : "",
                                                    backgroundRepeat: "no-repeat",
                                                    backgroundSize: "contain",
                                                  }}
                                                ></span> */}
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        top: "auto",
                                        // page.name === "Witnesses"
                                        //   ? `${index * 2 + 3}%`
                                        //   : "auto",
                                        left: "auto",
                                        minWidth: "auto",
                                        transform: "translate(10px, -20px)",
                                        right: width > 1400 ? "120px" : "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            padding: "0px 10px 0px 25px",
                                            height: "35px",
                                            cursor: "pointer",
                                            // background: "white",

                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);
                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", true);
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-between"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}
                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          // paddingLeft: "55px",
                                          height: "25px",
                                          padding: "0 10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {page?.panel_name}
                                        </span>
                                      </div>
                                      {panels?.length === 0 && (
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            // paddingLeft: "55px",
                                            height: "50px",
                                            padding: "0 10px",
                                            background: "var(--primary-2)",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "14px",
                                              color: "var(--primary-25)",
                                              width: "100%",
                                              // textTransform: "",
                                            }}
                                          >
                                            {toSentenceCase(`No ${page?.panel_name}`)}
                                          </span>
                                        </li>
                                      )}
                                      {panels.map((panel, panelIndex) => (
                                        <li
                                          key={panelIndex}
                                          className="d-flex align-items-center"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "25px",
                                          }}
                                          onMouseEnter={() => {
                                            setDocumentPanelsData(panel);
                                            setPanelMenuBar(panelIndex);
                                          }}
                                          onMouseLeave={() => {
                                            setDocumentPanelsData([]);
                                            setPanelMenuBar(null);
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer d-flex align-items-center"
                                            // style={{ gap: "5px" }}
                                            style={{
                                              color: "var(--primary-25)",
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  panelMenuBar === panelIndex
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                              }}
                                            />
                                            <span className="ms-2" style={{ fontWeight: "bold" }}>
                                              {panelIndex + 1}.
                                            </span>
                                            <span
                                              className="ms-2 whitespace-nowrap"
                                              style={{
                                                fontWeight: "bold",
                                                color: "var(--primary)",
                                              }}
                                            >
                                              {page?.name === "Offer" ? panel?.panel_name : ""}
                                              {page?.name !== "Offer"
                                                ? panel?.specialty
                                                  ? panel?.specialty.name
                                                  : panel?.panel_name
                                                    ? panel?.panel_name
                                                    : ""
                                                : ""}
                                            </span>
                                          </a>
                                          <ul
                                            className="document-pop-up-sidebar-menubar"
                                            style={{
                                              position: "absolute",
                                              // left: "auto",
                                              top:
                                                width < 1400
                                                  ? `${panelIndex * 2 + 18}%`
                                                  : `${10 + panelIndex * 2}%`,
                                              left: "auto",
                                              // top: "auto",
                                              minWidth: "auto",
                                              transform:
                                                width > 1400
                                                  ? `translate(0px, -${panelIndex + 15}%)`
                                                  : `translate(0px, -${panelIndex + 30}%)`,
                                              // right: "17.2%",
                                              right:
                                                page?.name === "Employment"
                                                  ? "89%"
                                                  : page?.name === "Reports"
                                                    ? "88%"
                                                    : page?.name === "Defendants"
                                                      ? "89%"
                                                      : page?.name === "Insurance"
                                                        ? "93%"
                                                        : page?.name === "Experts"
                                                          ? "88%"
                                                          : "90%",
                                              display: panelMenuBar === panelIndex ? "block" : "",
                                              width: "max-content",
                                            }}
                                          >
                                            <li
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "0px",
                                                height: "25px",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "black",
                                                  width: "100%",
                                                }}
                                              >
                                                <span
                                                  className="p-l-5 d-flex align-items-center"
                                                  style={{
                                                    width: "25px",
                                                    height: "25px",
                                                  }}
                                                >
                                                  <img
                                                    src={page.page_icon ?? ""}
                                                    className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                    // className="document-icons-width"
                                                    alt=""
                                                    style={{
                                                      width: "15px",
                                                      height: "15px",
                                                    }}
                                                  />
                                                </span>
                                                {documentPanelsData?.panel_name
                                                  ? documentPanelsData.panel_name
                                                  : ""}
                                              </span>
                                            </li>
                                            <li
                                              className="bg-primary-5 d-flex align-items-center"
                                              style={{
                                                paddingLeft: "55px",
                                                height: "25px",
                                                paddingRight: "10px",
                                                // background: "var(--primary-15)",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "var(--primary)",
                                                  width: "100%",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                Document Row Buttons
                                              </span>
                                            </li>
                                            {page_slots.map((slot, slotIndex) => {
                                              const docsInSlot = panel.documents?.filter(
                                                (doc) =>
                                                  doc.document_slot?.slot_number ===
                                                  slot?.slot_number
                                              );
                                              const handleClick = async () => {
                                                if (docsInSlot.length > 0) {
                                                  setPendingSlotAction({
                                                    slot,
                                                    docsInSlot,
                                                    page,
                                                    panel,
                                                  });
                                                  setConfirmationModal(true);
                                                  return;
                                                }

                                                await submitDocumentWithPanel({
                                                  slot,
                                                  page,
                                                  panel,
                                                });
                                              };

                                              return (
                                                slot.slot_number !== 0 && (
                                                  <li
                                                    key={slotIndex}
                                                    className="d-flex align-items-center"
                                                    style={{
                                                      padding: "0px 10px",
                                                      height: "25px",
                                                      cursor:
                                                        docsInSlot.length > 0
                                                          ? "default"
                                                          : "pointer",
                                                    }}
                                                    onClick={handleClick}
                                                  >
                                                    {slot.slot_number !== 0 && (
                                                      <span className="d-flex align-items-center justify-content-center">
                                                        {docsInSlot.length > 0 ? (
                                                          <i
                                                            className="ic ic-file-colored ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        ) : (
                                                          <img
                                                            src={UploadIcon}
                                                            className=" ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        )}
                                                      </span>
                                                    )}
                                                    {/* 
                                                          {slot.slot_number === 0 && (
                                                            <span className="d-flex align-items-center ms-2">
                                                              <img
                                                                src={page.page_icon ?? ""}
                                                                className="document-icons-width  cursor-pointer m-r-5"
                                                                alt=""
                                                              />
                                                              Attach to {page.name} Page
                                                            </span>
                                                          )} */}

                                                    {slot.slot_number !== 0 && (
                                                      <div
                                                        className={`d-flex align-items-center  ${
                                                          docsInSlot.length === 0
                                                            ? "hoverable-text"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          width: "calc(100% - 25px)",
                                                          fontWeight: "bold",
                                                          // height: "25px",
                                                          color:
                                                            docsInSlot.length === 0
                                                              ? "var(--primary-25)"
                                                              : "inherit",
                                                        }}
                                                      >
                                                        <>
                                                          <span className="ms-2 hoverable-text">
                                                            {slot.slot_number}.
                                                          </span>
                                                          <span className="ms-2 hoverable-text whitespace-nowrap">
                                                            {docsInSlot.length > 0
                                                              ? docsInSlot[0].file_name
                                                              : slot.slot_name
                                                                ? slot.slot_name
                                                                : "Available"}
                                                          </span>
                                                        </>
                                                      </div>
                                                    )}
                                                  </li>
                                                )
                                              );
                                            })}
                                          </ul>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                );
                              }

                              // If no panels, show page slots directly
                              if (page_slots.length > 0 && !page.panels) {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        // top:
                                        //   width < 1920
                                        //     ? `${index * 2 + 30}%`
                                        //     : `${10 + index * 1.5}%`,
                                        left: "auto",
                                        top: "auto",
                                        minWidth: "auto",
                                        transform:
                                          width > 1920
                                            ? "translate(10px, -20px)"
                                            : "translate(10px, -20px)",
                                        right: width > 1920 ? "120px" : "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            padding: "0px 10px 0px 25px",
                                            height: "35px",
                                            cursor: "pointer",
                                            // background: "white",

                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);
                                            // // Save as Docx blob with proper error handling
                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", "false");
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}

                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          paddingLeft: "55px",
                                          height: "25px",
                                          paddingRight: "10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center whitespace-nowrap p-r-5"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          Document Row Buttons
                                        </span>
                                      </div>

                                      {page_slots
                                        .filter((slot) => slot.slot_number !== 0)
                                        .map((slot, slotIndex) => {
                                          const docsInSlot = slotData.page_docs?.filter(
                                            (doc) =>
                                              doc.document_slot?.slot_number === slot?.slot_number
                                          );

                                          const handleClick = async () => {
                                            if (docsInSlot.length > 0) {
                                              setPendingSlotAction({ slot, docsInSlot, page });
                                              setConfirmationModal(true);
                                              return;
                                            }

                                            await submitDocument({ slot, page });
                                          };

                                          return (
                                            <li
                                              key={slotIndex}
                                              className="d-flex align-items-center"
                                              style={{
                                                height: "25px",
                                                cursor:
                                                  docsInSlot.length > 0 ? "default" : "pointer",
                                                padding: "0px 10px",
                                              }}
                                              onClick={handleClick}
                                            >
                                              {slot.slot_number !== 0 && (
                                                <span className="d-flex align-items-center justify-content-center">
                                                  {docsInSlot.length > 0 ? (
                                                    <i
                                                      className="ic ic-15 ic-file-colored cursor-pointer "
                                                      style={{
                                                        backgroundRepeat: "no-repeat",
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src={UploadIcon}
                                                      className=" ic-15 cursor-pointer"
                                                      style={{
                                                        backgroundRepeat: "no-repeat",
                                                      }}
                                                    />
                                                  )}
                                                </span>
                                              )}

                                              {/* {slot.slot_number === 0 && (
                                                        <div
                                                          className="d-flex align-items-center justify-content-center"
                                                          style={{
                                                            width: "100%",
                                                          }}
                                                        >
                                                          <span
                                                            className="d-flex align-items-center whitespace-nowrap "
                                                            style={{ fontWeight: "bold" }}
                                                          >
                                                          
                                                            Attach to {page.name} Page
                                                          </span>
                                                        </div>
                                                      )} */}

                                              {slot.slot_number !== 0 && (
                                                <div
                                                  className={`d-flex align-items-center  ${
                                                    docsInSlot.length === 0 ? "hoverable-text" : ""
                                                  }`}
                                                  style={{
                                                    width: "calc(100% - 25px)",
                                                    fontWeight: "bold",
                                                    color:
                                                      docsInSlot.length === 0
                                                        ? "var(--primary-25)"
                                                        : "inherit",
                                                  }}
                                                >
                                                  <>
                                                    <span className="ms-2 hoverable-text">
                                                      {slot.slot_number}.
                                                    </span>
                                                    <span className="ms-2 hoverable-text whitespace-nowrap">
                                                      {docsInSlot.length > 0
                                                        ? docsInSlot[0].file_name
                                                        : slot.slot_name
                                                          ? slot.slot_name
                                                          : "Available"}
                                                    </span>
                                                  </>
                                                </div>
                                              )}
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </li>
                                );
                              }
                            }

                            return null;
                          })}
                      </div>
                      <div
                        style={{
                          flex: "1",
                        }}
                      >
                        {rightCol &&
                          rightCol.map((page, _index) => {
                            // Find the corresponding slot data for the current page
                            const slotData = slotsData.find((slot) => slot.page.name === page.name);

                            if (
                              page.is_notes_category &&
                              slotData &&
                              slotData.page_slots.length > 0
                            ) {
                              const { panels, page_slots } = slotData;

                              // If panels exist, show panels first

                              if (
                                page_slots.length > 0 &&
                                page.name === "Treatment" &&
                                page.panels
                              ) {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        top: "auto",
                                        // page.name === "Witnesses"
                                        //   ? `${index * 2 + 3}%`
                                        //   : "auto",
                                        left: "auto",
                                        minWidth: "auto",
                                        transform: "translate(10px, -20px)",
                                        right: "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "35px",
                                            // padding: "0 10px",
                                            paddingTop: "0px",
                                            paddingLeft: "25px",
                                            paddingRight: "10px",
                                            paddingBottom: "0px",
                                            // background: "white",
                                            cursor: "pointer",
                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);
                                            // // Save as Docx blob with proper error handling
                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", true);
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-between"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}
                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          // paddingLeft: "55px",
                                          height: "25px",
                                          padding: "0 10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {page?.panel_name}
                                        </span>
                                      </div>
                                      {panels?.length === 0 && (
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            // paddingLeft: "55px",
                                            height: "50px",
                                            padding: "0 10px",
                                            background: "var(--primary-2)",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "14px",
                                              color: "var(--primary-25)",
                                              width: "100%",
                                              // textTransform: "capitalize",
                                            }}
                                          >
                                            {toSentenceCase(`No ${page?.panel_name}`)}
                                          </span>
                                        </li>
                                      )}
                                      {panels.map((panel, panelIndex) => (
                                        <li
                                          key={panelIndex}
                                          className="d-flex align-items-center"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "25px",
                                          }}
                                          onMouseEnter={() => {
                                            setDocumentPanelsData(panel);
                                            setPanelMenuBar(panelIndex);
                                          }}
                                          onMouseLeave={() => {
                                            setDocumentPanelsData([]);
                                            setPanelMenuBar(null);
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer d-flex align-items-center color-grey-2"
                                            style={{ gap: "0px", width: "100%" }}
                                          >
                                            {/* <span
                                                        style={{
                                                          display: "inline-block",
                                                          width: "17px",
                                                          height: "17px",
                                                          color: "#19395F",
                                                          transform: "rotate(180deg)",
                                                          backgroundImage:
                                                            panelMenuBar === panelIndex
                                                              ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                                              : "",
                                                          backgroundRepeat: "no-repeat",
                                                          backgroundSize: "contain",
                                                        }}
                                                      ></span> */}
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              {panelIndex + 1}
                                            </span>
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              <img
                                                src={TFIcon}
                                                alt="tf-icon"
                                                style={{
                                                  height: "25px",
                                                  width: "25px",
                                                  position: "relative",
                                                  right: "0px",
                                                  bottom: "0px",
                                                }}
                                              />
                                            </span>

                                            <span
                                              className="d-flex align-items-center p-r-5 whitespace-nowrap"
                                              style={{
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                color: "black",
                                                width: "calc(100% - 25px)",
                                                background: mixColorWithWhite(
                                                  panel?.specialty?.color,
                                                  10
                                                ),
                                              }}
                                            >
                                              <span
                                                style={{
                                                  background: panel?.specialty?.color,

                                                  fontSize: "16px",
                                                  fontWeight: "700",
                                                  height: "25px",
                                                  width: "25px",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  color: "white",
                                                  marginRight: "5px",
                                                }}
                                              >
                                                {panel?.specialty?.name[0] ?? ""}
                                              </span>
                                              {panel?.panel_name ? panel.panel_name : ""}
                                            </span>
                                          </a>
                                          <ul
                                            className="document-pop-up-sidebar-menubar"
                                            style={{
                                              position: "absolute",
                                              // left: "auto",
                                              top:
                                                width < 1400
                                                  ? `${panelIndex * 2 + 18}%`
                                                  : `${10 + panelIndex * 2}%`,
                                              left: "auto",
                                              // top: "auto",
                                              minWidth: "250px",
                                              transform:
                                                width > 1400
                                                  ? `translate(0px, -${panelIndex + 15}%)`
                                                  : `translate(0px, -${panelIndex + 30}%)`,
                                              // right: "17.2%",
                                              right: "91%",
                                              display: panelMenuBar === panelIndex ? "block" : "",
                                              width: "max-content",
                                            }}
                                          >
                                            <li
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "0px",
                                                height: "25px",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "black",
                                                  width: "100%",
                                                  // background: documentData
                                                  //   ? mixColorWithWhite(
                                                  //       documentPanelsData?.specialty?.color,
                                                  //       10
                                                  //     )
                                                  //   : "",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    background:
                                                      documentPanelsData?.specialty?.color,
                                                    fontSize: "16px",
                                                    fontWeight: "700",
                                                    height: "25px",
                                                    width: "25px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    color: "white",
                                                    marginRight: "5px",
                                                  }}
                                                >
                                                  {documentPanelsData?.specialty?.name[0] ?? ""}
                                                </span>
                                                {documentPanelsData?.panel_name
                                                  ? documentPanelsData.panel_name
                                                  : ""}
                                              </span>
                                            </li>
                                            <li
                                              className="bg-primary-5 d-flex align-items-center"
                                              style={{
                                                paddingLeft: "55px",
                                                height: "25px",
                                                paddingRight: "10px",
                                                // background: "var(--primary-15)",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "var(--primary)",
                                                  width: "100%",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                Document Row Buttons
                                              </span>
                                            </li>
                                            {page_slots.map((slot, slotIndex) => {
                                              const docsInSlot = panel.documents?.filter(
                                                (doc) =>
                                                  doc.document_slot?.slot_number ===
                                                  slot?.slot_number
                                              );
                                              const handleClick = async () => {
                                                if (docsInSlot.length > 0) {
                                                  setPendingSlotAction({
                                                    slot,
                                                    docsInSlot,
                                                    page,
                                                    panel,
                                                  });
                                                  setConfirmationModal(true);
                                                  return;
                                                }

                                                await submitDocumentWithPanel({
                                                  slot,
                                                  page,
                                                  panel,
                                                });
                                              };
                                              return (
                                                slot.slot_number !== 0 && (
                                                  <li
                                                    key={slotIndex}
                                                    className="d-flex align-items-center"
                                                    style={{
                                                      padding: "0px 10px",
                                                      height: "25px",
                                                      background:
                                                        slotIndex % 2 === 0
                                                          ? mixColorWithWhite(
                                                              panel?.specialty?.color,
                                                              2
                                                            )
                                                          : mixColorWithWhite(
                                                              panel?.specialty?.color,
                                                              4
                                                            ),
                                                      cursor:
                                                        docsInSlot.length > 0
                                                          ? "default"
                                                          : "pointer",
                                                    }}
                                                    onClick={handleClick}
                                                  >
                                                    {slot.slot_number !== 0 && (
                                                      <span className="d-flex align-items-center justify-content-center">
                                                        {docsInSlot.length > 0 ? (
                                                          <i
                                                            className="ic ic-15 ic-file-colored cursor-pointer "
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        ) : (
                                                          <img
                                                            src={UploadIcon}
                                                            className=" ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        )}
                                                      </span>
                                                    )}
                                                    {/* 
                                                          {slot.slot_number === 0 && (
                                                            <span className="d-flex align-items-center ms-2">
                                                              <img
                                                                src={page.page_icon ?? ""}
                                                                className="document-icons-width  cursor-pointer m-r-5"
                                                                alt=""
                                                              />
                                                              Attach to {page.name} Page
                                                            </span>
                                                          )} */}

                                                    {slot.slot_number !== 0 && (
                                                      <div
                                                        className={`d-flex align-items-center whitespace-nowrap  ${
                                                          docsInSlot.length === 0
                                                            ? "hoverable-text"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          width: "calc(100% - 25px)",
                                                          fontWeight: "bold",
                                                          color:
                                                            docsInSlot.length === 0
                                                              ? "var(--primary-25)"
                                                              : "inherit",

                                                          // height: "25px",
                                                        }}
                                                      >
                                                        <>
                                                          <span className="ms-2 hoverable-text">
                                                            {slot.slot_number}.
                                                          </span>
                                                          <span className="ms-2 hoverable-text">
                                                            {docsInSlot.length > 0
                                                              ? docsInSlot[0].file_name
                                                              : slot.slot_name
                                                                ? slot.slot_name
                                                                : "Available"}
                                                          </span>
                                                        </>
                                                      </div>
                                                    )}
                                                  </li>
                                                )
                                              );
                                            })}
                                          </ul>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                );
                              }

                              if (page_slots.length > 0 && page.panels && page.name === "Loans") {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        top: "auto",
                                        // page.name === "Witnesses"
                                        //   ? `${index * 2 + 3}%`
                                        //   : "auto",
                                        left: "auto",
                                        minWidth: "auto",
                                        transform: "translate(10px, -20px)",
                                        right: width > 1400 ? "120px" : "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            padding: "0px 10px 0px 25px",
                                            height: "35px",
                                            cursor: "pointer",
                                            // background: "white",

                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);
                                            // // Save as Docx blob with proper error handling
                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", true);
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-between"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}
                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          // paddingLeft: "55px",
                                          height: "25px",
                                          padding: "0 10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {page?.panel_name}
                                        </span>
                                      </div>
                                      {panels?.length === 0 && (
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            // paddingLeft: "55px",
                                            height: "50px",
                                            padding: "0 10px",
                                            background: "var(--primary-2)",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "14px",
                                              color: "var(--primary-25)",
                                              width: "100%",
                                              // textTransform: "",
                                            }}
                                          >
                                            {toSentenceCase(`No ${page?.panel_name}`)}
                                          </span>
                                        </li>
                                      )}
                                      {panels.map((panel, panelIndex) => (
                                        <li
                                          key={panelIndex}
                                          className="d-flex align-items-center"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "25px",
                                          }}
                                          onMouseEnter={() => {
                                            setDocumentPanelsData(panel);
                                            setPanelMenuBar(panelIndex);
                                          }}
                                          onMouseLeave={() => {
                                            setDocumentPanelsData([]);
                                            setPanelMenuBar(null);
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer d-flex align-items-center color-grey-2"
                                            style={{ gap: "0px", width: "100%" }}
                                          >
                                            {/* <span
                                                        style={{
                                                          display: "inline-block",
                                                          width: "17px",
                                                          height: "17px",
                                                          color: "#19395F",
                                                          transform: "rotate(180deg)",
                                                          backgroundImage:
                                                            panelMenuBar === panelIndex
                                                              ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                                              : "",
                                                          backgroundRepeat: "no-repeat",
                                                          backgroundSize: "contain",
                                                        }}
                                                      ></span> */}
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              {panelIndex + 1}
                                            </span>
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              {/* <img
                                                          src={TFIcon}
                                                          alt="tf-icon"
                                                          style={{
                                                            height: "25px",
                                                            width: "25px",
                                                            position: "relative",
                                                            right: "0px",
                                                            bottom: "0px",
                                                          }}
                                                        /> */}
                                            </span>

                                            <span
                                              className="d-flex align-items-center p-r-5 whitespace-nowrap"
                                              style={{
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                color: "black",
                                                width: "calc(100% - 25px)",
                                                background: mixColorWithWhite(
                                                  panel?.specialty?.color,
                                                  10
                                                ),
                                              }}
                                            >
                                              {page?.name === "Offer" ? panel?.panel_name : ""}
                                              {page?.name !== "Offer"
                                                ? panel?.specialty
                                                  ? panel?.specialty.name
                                                  : panel?.panel_name
                                                    ? panel?.panel_name
                                                    : ""
                                                : ""}
                                            </span>
                                          </a>
                                          {/* <a
                                                      className="cursor-pointer d-flex align-items-center"
                                                      // style={{ gap: "5px" }}
                                                      style={{
                                                        color: "var(--primary-25)",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display: "inline-block",
                                                          width: "17px",
                                                          height: "17px",
                                                          color: "#19395F",
                                                          transform: "rotate(180deg)",
                                                          backgroundImage:
                                                            panelMenuBar === panelIndex
                                                              ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                              : "",
                                                          backgroundRepeat: "no-repeat",
                                                          backgroundSize: "contain",
                                                        }}
                                                      />
                                                      <span className="ms-2" style={{ fontWeight: "bold" }}>
                                                        {panelIndex + 1}.
                                                      </span>
                                                      <span
                                                        className="ms-2 whitespace-nowrap"
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: "var(--primary)",
                                                        }}
                                                      >
                                                        {page?.name === "Offer" ? panel?.panel_name : ""}
                                                        {page?.name !== "Offer"
                                                          ? panel?.specialty
                                                            ? panel?.specialty.name
                                                            : panel?.panel_name
                                                              ? panel?.panel_name
                                                              : ""
                                                          : ""}
                                                      </span>
                                                    </a> */}
                                          <ul
                                            className="document-pop-up-sidebar-menubar"
                                            style={{
                                              position: "absolute",
                                              // left: "auto",
                                              top:
                                                width < 1400
                                                  ? `${panelIndex * 2 + 18}%`
                                                  : `${10 + panelIndex * 2}%`,
                                              left: "auto",
                                              // top: "auto",
                                              minWidth: "auto",
                                              transform:
                                                width > 1400
                                                  ? `translate(0px, -${panelIndex + 15}%)`
                                                  : `translate(0px, -${panelIndex + 30}%)`,
                                              // right: "17.2%",
                                              right: "88%",
                                              display: panelMenuBar === panelIndex ? "block" : "",
                                              width: "max-content",
                                            }}
                                          >
                                            <li
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "0px",
                                                height: "25px",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "black",
                                                  width: "100%",
                                                }}
                                              >
                                                <span
                                                  className="p-l-5 d-flex align-items-center"
                                                  style={{
                                                    width: "25px",
                                                    height: "25px",
                                                  }}
                                                >
                                                  <img
                                                    src={page.page_icon ?? ""}
                                                    className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                    // className="document-icons-width"
                                                    alt=""
                                                    style={{
                                                      width: "15px",
                                                      height: "15px",
                                                    }}
                                                  />
                                                </span>
                                                {documentPanelsData?.panel_name
                                                  ? documentPanelsData.panel_name
                                                  : ""}
                                              </span>
                                            </li>
                                            <li
                                              className="bg-primary-5 d-flex align-items-center"
                                              style={{
                                                paddingLeft: "55px",
                                                height: "25px",
                                                paddingRight: "10px",
                                                // background: "var(--primary-15)",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "var(--primary)",
                                                  width: "100%",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                Document Row Buttons
                                              </span>
                                            </li>
                                            {page_slots.map((slot, slotIndex) => {
                                              const docsInSlot = panel.documents?.filter(
                                                (doc) =>
                                                  doc.document_slot?.slot_number ===
                                                  slot?.slot_number
                                              );
                                              const handleClick = async () => {
                                                if (docsInSlot.length > 0) {
                                                  setPendingSlotAction({
                                                    slot,
                                                    docsInSlot,
                                                    page,
                                                    panel,
                                                  });
                                                  setConfirmationModal(true);
                                                  return;
                                                }

                                                await submitDocumentWithPanel({
                                                  slot,
                                                  page,
                                                  panel,
                                                });
                                              };
                                              return (
                                                slot.slot_number !== 0 && (
                                                  <li
                                                    key={slotIndex}
                                                    className="d-flex align-items-center"
                                                    style={{
                                                      padding: "0px 10px",
                                                      height: "25px",
                                                      cursor:
                                                        docsInSlot.length > 0
                                                          ? "default"
                                                          : "pointer",
                                                    }}
                                                    onClick={handleClick}
                                                  >
                                                    {slot.slot_number !== 0 && (
                                                      <span className="d-flex align-items-center justify-content-center">
                                                        {docsInSlot.length > 0 ? (
                                                          <i
                                                            className="ic ic-15 ic-file-colored cursor-pointer "
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        ) : (
                                                          <img
                                                            src={UploadIcon}
                                                            className=" ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        )}
                                                      </span>
                                                    )}
                                                    {/* 
                                                          {slot.slot_number === 0 && (
                                                            <span className="d-flex align-items-center ms-2">
                                                              <img
                                                                src={page.page_icon ?? ""}
                                                                className="document-icons-width  cursor-pointer m-r-5"
                                                                alt=""
                                                              />
                                                              Attach to {page.name} Page
                                                            </span>
                                                          )} */}

                                                    {slot.slot_number !== 0 && (
                                                      <div
                                                        className={`d-flex align-items-center  ${
                                                          docsInSlot.length === 0
                                                            ? "hoverable-text"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          width: "calc(100% - 25px)",
                                                          fontWeight: "bold",
                                                          // height: "25px",
                                                          color:
                                                            docsInSlot.length === 0
                                                              ? "var(--primary-25)"
                                                              : "inherit",
                                                        }}
                                                      >
                                                        <>
                                                          <span className="ms-2 hoverable-text">
                                                            {slot.slot_number}.
                                                          </span>
                                                          <span className="ms-2 hoverable-text whitespace-nowrap">
                                                            {docsInSlot.length > 0
                                                              ? docsInSlot[0].file_name
                                                              : slot.slot_name
                                                                ? slot.slot_name
                                                                : "Available"}
                                                          </span>
                                                        </>
                                                      </div>
                                                    )}
                                                  </li>
                                                )
                                              );
                                            })}
                                          </ul>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                );
                              }

                              if (page_slots.length > 0 && page.panels) {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      {/* <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "17px",
                                                    height: "17px",
                                                    color: "#19395F",
                                                    transform: "rotate(180deg)",
                                                    backgroundImage:
                                                      showMenuBar === index
                                                        ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                                        : "",
                                                    backgroundRepeat: "no-repeat",
                                                    backgroundSize: "contain",
                                                  }}
                                                ></span> */}
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        top: "auto",
                                        // page.name === "Witnesses"
                                        //   ? `${index * 2 + 3}%`
                                        //   : "auto",
                                        left: "auto",
                                        minWidth: "auto",
                                        transform: "translate(10px, -20px)",
                                        right: width > 1400 ? "120px" : "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            padding: "0px 10px 0px 25px",
                                            height: "35px",
                                            cursor: "pointer",
                                            // background: "white",

                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);
                                            // // Save as Docx blob with proper error handling
                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", true);
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-between"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}
                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          // paddingLeft: "55px",
                                          height: "25px",
                                          padding: "0 10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {page?.panel_name}
                                        </span>
                                      </div>
                                      {panels?.length === 0 && (
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            // paddingLeft: "55px",
                                            height: "50px",
                                            padding: "0 10px",
                                            background: "var(--primary-2)",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "14px",
                                              color: "var(--primary-25)",
                                              width: "100%",
                                              // textTransform: "",
                                            }}
                                          >
                                            {toSentenceCase(`No ${page?.panel_name}`)}
                                          </span>
                                        </li>
                                      )}
                                      {panels.map((panel, panelIndex) => (
                                        <li
                                          key={panelIndex}
                                          className="d-flex align-items-center"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "25px",
                                          }}
                                          onMouseEnter={() => {
                                            setDocumentPanelsData(panel);
                                            setPanelMenuBar(panelIndex);
                                          }}
                                          onMouseLeave={() => {
                                            setDocumentPanelsData([]);
                                            setPanelMenuBar(null);
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer d-flex align-items-center"
                                            // style={{ gap: "5px" }}
                                            style={{
                                              color: "var(--primary-25)",
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  panelMenuBar === panelIndex
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                              }}
                                            />
                                            <span className="ms-2" style={{ fontWeight: "bold" }}>
                                              {panelIndex + 1}.
                                            </span>
                                            <span
                                              className="ms-2 whitespace-nowrap"
                                              style={{
                                                fontWeight: "bold",
                                                color: "var(--primary)",
                                              }}
                                            >
                                              {page?.name === "Offer" ? panel?.panel_name : ""}
                                              {page?.name !== "Offer"
                                                ? panel?.specialty
                                                  ? panel?.specialty.name
                                                  : panel?.panel_name
                                                    ? panel?.panel_name
                                                    : ""
                                                : ""}
                                            </span>
                                          </a>
                                          <ul
                                            className="document-pop-up-sidebar-menubar"
                                            style={{
                                              position: "absolute",
                                              // left: "auto",
                                              top:
                                                width < 1400
                                                  ? `${panelIndex * 2 + 18}%`
                                                  : `${10 + panelIndex * 2}%`,
                                              left: "auto",
                                              // top: "auto",
                                              minWidth: "auto",
                                              transform:
                                                width > 1400
                                                  ? `translate(0px, -${panelIndex + 15}%)`
                                                  : `translate(0px, -${panelIndex + 30}%)`,
                                              // right: "17.2%",
                                              right:
                                                page?.name === "Employment"
                                                  ? "89%"
                                                  : page?.name === "Reports"
                                                    ? "88%"
                                                    : page?.name === "Defendants"
                                                      ? "89%"
                                                      : page?.name === "Insurance"
                                                        ? "93%"
                                                        : page?.name === "Experts"
                                                          ? "88%"
                                                          : "90%",
                                              display: panelMenuBar === panelIndex ? "block" : "",
                                              width: "max-content",
                                            }}
                                          >
                                            <li
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "0px",
                                                height: "25px",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "black",
                                                  width: "100%",
                                                }}
                                              >
                                                <span
                                                  className="p-l-5 d-flex align-items-center"
                                                  style={{
                                                    width: "25px",
                                                    height: "25px",
                                                  }}
                                                >
                                                  <img
                                                    src={page.page_icon ?? ""}
                                                    className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                    // className="document-icons-width"
                                                    alt=""
                                                    style={{
                                                      width: "15px",
                                                      height: "15px",
                                                    }}
                                                  />
                                                </span>
                                                {documentPanelsData?.panel_name
                                                  ? documentPanelsData.panel_name
                                                  : ""}
                                              </span>
                                            </li>
                                            <li
                                              className="bg-primary-5 d-flex align-items-center"
                                              style={{
                                                paddingLeft: "55px",
                                                height: "25px",
                                                paddingRight: "10px",
                                                // background: "var(--primary-15)",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "var(--primary)",
                                                  width: "100%",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                Document Row Buttons
                                              </span>
                                            </li>
                                            {page_slots.map((slot, slotIndex) => {
                                              const docsInSlot = panel.documents?.filter(
                                                (doc) =>
                                                  doc.document_slot?.slot_number ===
                                                  slot?.slot_number
                                              );
                                              const handleClick = async () => {
                                                if (docsInSlot.length > 0) {
                                                  setPendingSlotAction({
                                                    slot,
                                                    docsInSlot,
                                                    page,
                                                    panel,
                                                  });
                                                  setConfirmationModal(true);
                                                  return;
                                                }

                                                await submitDocumentWithPanel({
                                                  slot,
                                                  page,
                                                  panel,
                                                });
                                              };

                                              return (
                                                slot.slot_number !== 0 && (
                                                  <li
                                                    key={slotIndex}
                                                    className="d-flex align-items-center"
                                                    style={{
                                                      padding: "0px 10px",
                                                      height: "25px",
                                                      cursor:
                                                        docsInSlot.length > 0
                                                          ? "default"
                                                          : "pointer",
                                                    }}
                                                    onClick={handleClick}
                                                  >
                                                    {slot.slot_number !== 0 && (
                                                      <span className="d-flex align-items-center justify-content-center">
                                                        {docsInSlot.length > 0 ? (
                                                          <i
                                                            className="ic ic-file-colored ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        ) : (
                                                          <img
                                                            src={UploadIcon}
                                                            className=" ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        )}
                                                      </span>
                                                    )}
                                                    {/* 
                                                          {slot.slot_number === 0 && (
                                                            <span className="d-flex align-items-center ms-2">
                                                              <img
                                                                src={page.page_icon ?? ""}
                                                                className="document-icons-width  cursor-pointer m-r-5"
                                                                alt=""
                                                              />
                                                              Attach to {page.name} Page
                                                            </span>
                                                          )} */}

                                                    {slot.slot_number !== 0 && (
                                                      <div
                                                        className={`d-flex align-items-center  ${
                                                          docsInSlot.length === 0
                                                            ? "hoverable-text"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          width: "calc(100% - 25px)",
                                                          fontWeight: "bold",
                                                          // height: "25px",
                                                          color:
                                                            docsInSlot.length === 0
                                                              ? "var(--primary-25)"
                                                              : "inherit",
                                                        }}
                                                      >
                                                        <>
                                                          <span className="ms-2 hoverable-text">
                                                            {slot.slot_number}.
                                                          </span>
                                                          <span className="ms-2 hoverable-text whitespace-nowrap">
                                                            {docsInSlot.length > 0
                                                              ? docsInSlot[0].file_name
                                                              : slot.slot_name
                                                                ? slot.slot_name
                                                                : "Available"}
                                                          </span>
                                                        </>
                                                      </div>
                                                    )}
                                                  </li>
                                                )
                                              );
                                            })}
                                          </ul>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                );
                              }

                              // If no panels, show page slots directly
                              if (page_slots.length > 0 && !page.panels) {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        // top:
                                        //   width < 1920
                                        //     ? `${index * 2 + 30}%`
                                        //     : `${10 + index * 1.5}%`,
                                        left: "auto",
                                        top: "auto",
                                        minWidth: "auto",
                                        transform:
                                          width > 1920
                                            ? "translate(10px, -20px)"
                                            : "translate(10px, -20px)",
                                        right: width > 1920 ? "120px" : "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            padding: "0px 10px 0px 25px",
                                            height: "35px",
                                            cursor: "pointer",
                                            // background: "white",

                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);
                                            // // Save as Docx blob with proper error handling
                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", "false");
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}

                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          paddingLeft: "55px",
                                          height: "25px",
                                          paddingRight: "10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center whitespace-nowrap p-r-5"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          Document Row Buttons
                                        </span>
                                      </div>

                                      {page_slots
                                        .filter((slot) => slot.slot_number !== 0)
                                        .map((slot, slotIndex) => {
                                          const docsInSlot = slotData.page_docs?.filter(
                                            (doc) =>
                                              doc.document_slot?.slot_number === slot?.slot_number
                                          );

                                          const handleClick = async () => {
                                            if (docsInSlot.length > 0) {
                                              setPendingSlotAction({ slot, docsInSlot, page });
                                              setConfirmationModal(true);
                                              return;
                                            }

                                            await submitDocument({ slot, page });
                                          };

                                          return (
                                            <li
                                              key={slotIndex}
                                              className="d-flex align-items-center"
                                              style={{
                                                height: "25px",
                                                cursor:
                                                  docsInSlot.length > 0 ? "default" : "pointer",
                                                padding: "0px 10px",
                                              }}
                                              onClick={handleClick}
                                            >
                                              {slot.slot_number !== 0 && (
                                                <span className="d-flex align-items-center justify-content-center">
                                                  {docsInSlot.length > 0 ? (
                                                    <i
                                                      className="ic ic-15 ic-file-colored cursor-pointer "
                                                      style={{
                                                        backgroundRepeat: "no-repeat",
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src={UploadIcon}
                                                      className=" ic-15 cursor-pointer"
                                                      style={{
                                                        backgroundRepeat: "no-repeat",
                                                      }}
                                                    />
                                                  )}
                                                </span>
                                              )}

                                              {/* {slot.slot_number === 0 && (
                                                        <div
                                                          className="d-flex align-items-center justify-content-center"
                                                          style={{
                                                            width: "100%",
                                                          }}
                                                        >
                                                          <span
                                                            className="d-flex align-items-center whitespace-nowrap "
                                                            style={{ fontWeight: "bold" }}
                                                          >
                                                          
                                                            Attach to {page.name} Page
                                                          </span>
                                                        </div>
                                                      )} */}

                                              {slot.slot_number !== 0 && (
                                                <div
                                                  className={`d-flex align-items-center  ${
                                                    docsInSlot.length === 0 ? "hoverable-text" : ""
                                                  }`}
                                                  style={{
                                                    width: "calc(100% - 25px)",
                                                    fontWeight: "bold",
                                                    color:
                                                      docsInSlot.length === 0
                                                        ? "var(--primary-25)"
                                                        : "inherit",
                                                  }}
                                                >
                                                  <>
                                                    <span className="ms-2 hoverable-text">
                                                      {slot.slot_number}.
                                                    </span>
                                                    <span className="ms-2 hoverable-text whitespace-nowrap">
                                                      {docsInSlot.length > 0
                                                        ? docsInSlot[0].file_name
                                                        : slot.slot_name
                                                          ? slot.slot_name
                                                          : "Available"}
                                                    </span>
                                                  </>
                                                </div>
                                              )}
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </li>
                                );
                              }
                            }

                            return null;
                          })}
                      </div>

                      {pages?.length === 0 &&
                        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map((index) => (
                          <li key={index} className="">
                            <a
                              className="cursor-pointer d-flex align-items-center justify-content-center shimmer-effect relative overflow-hidden"
                              style={{
                                height: width > 2120 ? "25px" : "25px",
                                backgroundColor:
                                  index % 2 === 0 ? "var(--primary-2)" : "var(--primary-4)",
                              }}
                            >
                              <div
                                className="absolute inset-0"
                                style={{
                                  animation: "shimmer 2s infinite linear",
                                  background:
                                    "linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%)",
                                  backgroundSize: "1000px 100%",
                                }}
                              >
                                {index === 7 && (
                                  <span
                                    style={{
                                      color: "var(--primary-50)",
                                      fontSize: "14px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    Attach Document To Case First
                                  </span>
                                )}
                              </div>
                            </a>
                          </li>
                        ))}
                    </ul>
                  </div>

                  <div
                    className=""
                    style={{
                      display: height <= 1024 ? "flex" : "flex",
                      justifyContent: height <= 1024 ? "space-between" : "initial",
                      background: "white",
                      padding: "5px",
                      gap: "5px",
                      flexDirection: height <= 1024 ? "row" : "column",
                    }}
                  >
                    {/* Chat Document Link Dropdown */}

                    <div className="tile-row w-100  center-content my-auto">
                      <div className="dropdown  d-flex" ref={dropdownRefs.chatDoc}>
                        <button
                          className={`btn height-25 bottom-sidebar-buttons-things  dropdown-toggle position-relative d-flex align-items-center justify-content-center w-100 form-select has-no-bg position-relative doc-rev-btn rotate-btn ${dropdownOpen.chatDoc ? "show" : ""}`}
                          type="button"
                          // onClick={() => toggleDropdown("chatDoc")}
                          onClick={handleShow}
                          aria-haspopup="true"
                          aria-expanded={dropdownOpen.chatDoc}
                        >
                          <span className="ic-15 d-flex align-items-center justify-content-center">
                            {/* <i className="ic ic-19 ic-chat-3d d-flex align-items-cente justify-content-center" /> */}
                            <NewChatIcon />
                          </span>
                          {height <= 1024 ? "Chat" : "Chat About Draft"}
                        </button>
                        {dropdownOpen.chatDoc && (
                          <div className="dropdown-menu show">{/* Add dropdown items here */}</div>
                        )}
                      </div>
                    </div>

                    {/* Request Document Review Button */}

                    <div className="tile-row w-100 center-content my-auto">
                      <div className="dropdown d-flex" ref={dropdownRefs.docReview}>
                        <button
                          className={`btn height-25 bottom-sidebar-buttons-things  dropdown-toggle position-relative d-flex align-items-center justify-content-center w-100 form-select has-no-bg position-relative doc-rev-btn rotate-btn ${dropdownOpen.docReview ? "show" : ""}`}
                          type="button"
                          onClick={toggleModal}
                          aria-haspopup="true"
                          aria-expanded={dropdownOpen.docReview}
                        >
                          <span className="ic-15 d-flex align-items-center justify-content-center">
                            <img
                              src="https://simplefirm-bucket.s3.amazonaws.com/static/images/Tasks_page_icon_color.svg"
                              className="ic ic-15 cursor-pointer d-flex align-items-center justify-content-center"
                            />
                          </span>

                          {height <= 1024 ? "Review" : "Request Draft Review"}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Bottom Buttons */}
                  <div
                    className="d-flex flex-column"
                    style={{ gap: height <= 1024 ? "5px" : "40px" }}
                  >
                    <div className="ps-1 pe-1 w-100">
                      <button
                        className="btn btn-primary col w-100 height-25 d-flex align-items-center justify-content-center"
                        style={{
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                        onClick={handleCloseTab}
                      >
                        Close Draft
                      </button>
                    </div>
                    <div className="bottom-content side-bar-padding">
                      <div className="m-b-5 six-buttons m-l-0 m-r-0">
                        <button
                          className="btn btn-primary col height-25 d-flex align-items-center justify-content-center"
                          style={{
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                          onClick={print}
                        >
                          Print
                        </button>
                        <button
                          className="btn btn-primary download-btn col height-25 d-flex align-items-center justify-content-center"
                          onClick={download}
                          style={{
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          Download
                        </button>
                        <button
                          className="btn btn-primary col height-25 d-flex align-items-center justify-content-center"
                          onClick={sendEmail}
                          style={{
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          Email
                        </button>

                        <button
                          type="button"
                          onClick={deleteDoc}
                          className="btn btn-secondary height-25 d-flex align-items-center justify-content-center flex-g"
                          style={{
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {type === "LetterTemplate" ? (
            <>
              <div className="row mx-auto">
                <div className="col-sm-12 p-l-5 pe-0">
                  <div>
                    <input
                      type="text"
                      className="form-control col height-25 p-l-5 p-0 d-flex align-items-center"
                      value={renameDoc}
                      onChange={(e) => setRenameDoc(e.target.value)}
                    />
                  </div>
                  <div className="d-flex justify-content-end m-t-5 m-b-5">
                    <button
                      type="button"
                      className="btn btn-primary fw-bold  height-25 d-flex align-items-center justify-content-center"
                      onClick={renameDocFileName}
                    >
                      Rename
                    </button>
                  </div>
                </div>
              </div>

              <div className="row mx-auto">
                <div
                  className="col-sm-12 p-l-5 pe-0 custom-select-new-provider"
                  ref={pageDropdownRef}
                >
                  {/* {true && ( */}

                  <>
                    <div
                      className="dropdown-button form-control pt-0 pb-0  pe-0 rounded-0 height-25 d-flex align-items-center"
                      onClick={() => setDropdownOpenManual((prev) => !prev)}
                      style={{
                        paddingLeft: selectedPageOption ? "0px" : "5px",
                      }}
                    >
                      <span id="selectedOption">
                        {selectedPageOption ? (
                          <div
                            className="d-flex p-l-5 align-items-center justify-content-start "
                            style={{
                              height: "25px",
                              fontSize: "16px",
                              color: "black",
                              fontWeight: "700",
                              gap: "5px",
                            }}
                          >
                            {selectedPageOption?.label}
                          </div>
                        ) : (
                          "Select a Page"
                        )}
                      </span>
                    </div>

                    {/* Dropdown menu */}
                    {dropdownOpenManual && (
                      <div
                        className="dropdown-menu p-0 mt-0"
                        style={{
                          width: "100%",
                          border: "1px solid #ced4da",
                          // borderRadius: "2px",
                          scrollbarWidth: "none",
                          maxHeight: "328px",
                          fontSize: "16px",
                          overflowY: "auto",
                          maxWidth: "210px",
                          left: "5px",
                        }}
                      >
                        {dropdownPages?.map((special) => (
                          <div className={`has-speciality-color-${special?.value}`}>
                            <div
                              key={special.value}
                              className="dropdown-option bg-speciality d-flex align-items-center height-25"
                              style={{
                                color: "black",
                                fontWeight: "700",
                                fontSize: "16px",
                                cursor: "pointer",
                                paddingLeft: "5px",
                              }}
                              onClick={() => handlePageChange(special)}
                            >
                              {special.label}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                  {/* )} */}
                </div>
              </div>
              <div className="row mx-auto ">
                {/* Column 1 (Odd-indexed items) */}
                <div className="col-sm-12 p-l-5 pe-0 text-center">
                  <div className="icon-text-boxes">
                    {dropdownVariables
                      ?.filter((_, index) => index % 2 === 0)
                      .map((variable, index) =>
                        variable.button_name ? (
                          <div
                            key={index}
                            className="text-center height-25 btn-primary-lighter-2 font-weight-semibold cursor-pointer m-t-5"
                            id="no-vertical-border"
                            onClick={() => handleVariableChange2(`{{${variable.name}}}`, container)}
                          >
                            <p className="name">{variable.button_name}</p>
                          </div>
                        ) : null
                      )}
                  </div>
                </div>

                {/* Column 2 (Even-indexed items) */}
                <div className="col-sm-12 p-l-5 pe-0 text-center">
                  <div className="icon-text-boxes">
                    {dropdownVariables
                      ?.filter((_, index) => index % 2 !== 0)
                      .map((variable, index) =>
                        variable.button_name ? (
                          <div
                            key={index} // Unique key for second column
                            className="text-center height-25 btn-primary-lighter-2 font-weight-semibold cursor-pointer m-t-5"
                            id="no-vertical-border"
                            onClick={() => handleVariableChange2(`{{${variable.name}}}`, container)}
                          >
                            <p className="name">{variable.button_name}</p>
                          </div>
                        ) : null
                      )}
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>

        {chatDocumentThread && updatedUser && (
          <div
            style={{
              minWidth: "200px",
              flex: "0 0 30%",
              // maxWidth: "460px",
              height: "100%",
            }}
          >
            <ChatWindow
              user={updatedUser}
              messages={messages}
              typingUsers={typingUsers}
              handleSendMessage={(text) => sendMessage(updatedUser?.id, text)}
              handleTyping={handleTyping}
              markAsRead={markAsRead}
              loadMoreMessages={loadMoreMessages}
              source={"chat"}
            />
          </div>
        )}
      </div>

      {confirmationModal && (
        <Modal
          show={confirmationModal}
          // onBackdropClick={handleCancel}
          onHide={handleCancel}
          // backdrop="static"
          centered
        >
          <Modal.Header
            style={{
              borderBottom: "0px",
            }}
            className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
          >
            <Modal.Title
              className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
              id="modal_title"
              style={{ fontSize: "14px", fontWeight: "600" }}
            >
              Document Already Exists
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="p-3">
            <p className="m-b-5">A document already exists in this page slot.</p>
            <p className="text-muted small">
              Choose what you would like to do with the existing document.
            </p>
          </Modal.Body>

          <Modal.Footer
            className=" p-0 mt-0 padding-outside-btn-new-provider"
            style={{ borderTop: "none" }}
          >
            <Button
              className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
              variant="secondary"
              onClick={handleCancel}
            >
              Cancel
            </Button>

            <div
              className="d-flex align-items-center"
              style={{
                gap: "5px",
              }}
            >
              <Button
                className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
                variant="success"
                onClick={handleMoveExisting}
              >
                Move existing document
              </Button>

              <Button
                className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
                variant="danger"
                onClick={handleDeleteExisting}
              >
                Delete existing document
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      )}

      {showModal && (
        <ChatDocumentModalWord
          showModal={showModal}
          handleClose={handleClose}
          users={users}
          loading={chatLoading}
          error={chatError}
          sendMessage={sendMessage}
          searchUsers={searchUsers}
          setChatDocumentThread={setChatDocumentThread}
          setUpdatedUser={setUpdatedUser}
          handleSelectUser={handleSelectUser}
          pageName={"wordprocessor"}
          setPdfDocId={setPdfDocId}
          contentUpdated={contentUpdated}
          pdfDocId={pdfDocId}
          draftId={draftId}
          container={container}
          docName={state.tempName}
        />
      )}
    </>
  );
}

export default WPBaseDraftPage;
